import { GDQEventGame, GDQPuzzle } from '../types';

// Let's generate extremely detailed, beautiful SVGs representation for puzzles
// These render as gorgeous scalable vector art on 55" screens without pixelation!

export const SVG_WEDDING_PUZZLE_1 = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 700" width="100%" height="100%">
  <defs>
    <linearGradient id="wedGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="%23ffafbd" />
      <stop offset="50%" stop-color="%23ffc3a0" />
      <stop offset="100%" stop-color="%23ff9a9e" />
    </linearGradient>
  </defs>
  <rect width="100%" height="100%" fill="url(%23wedGrad1)" />
  <circle cx="250" cy="280" r="140" fill="none" stroke="white" stroke-width="8" opacity="0.6"/>
  <circle cx="250" cy="280" r="120" fill="none" stroke="white" stroke-width="2" opacity="0.4"/>
  <path d="M 250 120 C 320 80, 420 180, 250 350 C 80 180, 180 80, 250 120 Z" fill="%23e57373" stroke="white" stroke-width="4"/>
  <path d="M 210 260 L 290 260 M 250 220 L 250 300" stroke="white" stroke-width="8" stroke-linecap="round"/>
  <!-- Decorative Flowers -->
  <circle cx="120" cy="500" r="30" fill="%23fff275" opacity="0.9"/>
  <circle cx="150" cy="530" r="35" fill="%23ff8b94" opacity="0.8"/>
  <circle cx="380" cy="500" r="30" fill="%23fff275" opacity="0.9"/>
  <circle cx="350" cy="530" r="35" fill="%23ff8b94" opacity="0.8"/>
  <!-- Wedding Rings linked -->
  <circle cx="230" cy="460" r="40" fill="none" stroke="%23ffd700" stroke-width="12"/>
  <circle cx="270" cy="460" r="40" fill="none" stroke="%23ffd700" stroke-width="12"/>
  <text x="50%" y="620" dominant-baseline="middle" text-anchor="middle" font-family="'Cinzel', serif" font-weight="bold" font-size="28" fill="white">Bridal Joy</text>
  <text x="50%" y="650" dominant-baseline="middle" text-anchor="middle" font-family="'Inter', sans-serif" font-size="16" fill="white">Sarah &amp; Jonathan's Sacred Promise</text>
</svg>`;

export const SVG_WEDDING_PUZZLE_2 = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 700" width="100%" height="100%">
  <defs>
    <linearGradient id="wedGrad2" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="%23fed6e3" />
      <stop offset="100%" stop-color="%23a8ffd3" />
    </linearGradient>
  </defs>
  <rect width="100%" height="100%" fill="url(%23wedGrad2)" />
  <g transform="translate(150, 200)">
    <!-- Bible representation -->
    <rect x="0" y="0" width="200" height="260" rx="15" fill="%235c3d2e" stroke="white" stroke-width="4"/>
    <rect x="15" y="10" width="170" height="240" rx="10" fill="%23f7ecdf"/>
    <!-- Page indicator line -->
    <line x1="100" y1="10" x2="100" y2="250" stroke="%238d6e63" stroke-width="2"/>
    <path d="M 50 130 C 70 80, 130 80, 150 130" fill="none" stroke="%23d32f2f" stroke-width="6" stroke-linecap="round"/>
    <circle cx="100" cy="110" r="15" fill="%23d32f2f"/>
  </g>
  <path d="M100 560 L400 560" stroke="%233a506b" stroke-width="6"/>
  <text x="50%" y="100" dominant-baseline="middle" text-anchor="middle" font-family="'Cinzel', serif" font-weight="bold" font-size="28" fill="%233a506b">Ring of Covenant</text>
  <text x="50%" y="600" dominant-baseline="middle" text-anchor="middle" font-family="'Inter', sans-serif" font-size="18" fill="%233a506b" font-weight="600">Bound in Heaven</text>
</svg>`;

export const SVG_BIRTHDAY_PUZZLE_1 = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 700" width="100%" height="100%">
  <defs>
    <linearGradient id="bdayGrad" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="%234facfe" />
      <stop offset="100%" stop-color="%2300f2fe" />
    </linearGradient>
  </defs>
  <rect width="100%" height="100%" fill="url(%23bdayGrad)" />
  <!-- Giant Glowing golden crown representing life and wisdom -->
  <path d="M 100 380 L 150 200 L 210 260 L 250 150 L 290 260 L 350 200 L 400 380 Z" fill="%23ffd700" stroke="white" stroke-width="6" stroke-linejoin="round"/>
  <rect x="100" y="380" width="300" height="40" rx="10" fill="%23ffb300" stroke="white" stroke-width="4"/>
  <!-- Crown Jewels -->
  <circle cx="150" cy="200" r="12" fill="%23e91e63" stroke="white" stroke-width="2"/>
  <circle cx="250" cy="150" r="15" fill="%239c27b0" stroke="white" stroke-width="2"/>
  <circle cx="350" cy="200" r="12" fill="%23e91e63" stroke="white" stroke-width="2"/>
  <circle cx="250" cy="400" r="10" fill="%2303a9f4"/>
  <circle cx="180" cy="400" r="10" fill="%2303a9f4"/>
  <circle cx="320" cy="400" r="10" fill="%2303a9f4"/>
  <text x="50%" y="520" dominant-baseline="middle" text-anchor="middle" font-family="'Cinzel', serif" font-weight="bold" font-size="32" fill="white">Crown of Life</text>
  <text x="50%" y="570" dominant-baseline="middle" text-anchor="middle" font-family="'Inter', sans-serif" font-size="18" fill="white">Celebrating David's 50 Years</text>
</svg>`;

export const SVG_GRADUATION_PUZZLE_1 = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 700" width="100%" height="100%">
  <defs>
    <linearGradient id="gradGrad" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="%2313547a" />
      <stop offset="100%" stop-color="%2380d0c7" />
    </linearGradient>
  </defs>
  <rect width="100%" height="100%" fill="url(%23gradGrad)" />
  <!-- Graduation Cap -->
  <path d="M 250 180 L 420 240 L 250 300 L 80 240 Z" fill="%231a252f" stroke="white" stroke-width="5"/>
  <rect x="180" y="270" width="140" height="90" fill="%231a252f"/>
  <path d="M 400 250 C 400 320, 420 350, 430 380" fill="none" stroke="%23ffcc00" stroke-width="6" stroke-linecap="round"/>
  <!-- Radiant Bible/Book of Knowledge -->
  <rect x="120" y="420" width="260" height="60" rx="10" fill="white" stroke="%231a252f" stroke-width="4"/>
  <rect x="140" y="410" width="220" height="15" rx="5" fill="%23ffd700"/>
  <text x="50%" y="560" dominant-baseline="middle" text-anchor="middle" font-family="'Cinzel', serif" font-weight="bold" font-size="30" fill="white">Class of 2026</text>
</svg>`;

export const SVG_CHURCH_PUZZLE_1 = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 700" width="100%" height="100%">
  <defs>
    <linearGradient id="churchGrad" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="%23667eea" />
      <stop offset="100%" stop-color="%23764ba2" />
    </linearGradient>
  </defs>
  <rect width="100%" height="100%" fill="url(%23churchGrad)" />
  <!-- Radiant Stained Glass window with a Cross -->
  <path d="M 120 450 L 120 280 C 120 180, 380 180, 380 280 L 380 450 Z" fill="%232d3748" stroke="white" stroke-width="12"/>
  <path d="M 250 180 L 250 430 M 170 280 L 330 280" stroke="%23ffeb3b" stroke-width="16" stroke-linecap="round"/>
  <circle cx="250" cy="280" r="50" fill="none" stroke="%23fff" stroke-width="4" stroke-dasharray="10 5"/>
  <text x="50%" y="540" dominant-baseline="middle" text-anchor="middle" font-family="'Cinzel', serif" font-weight="bold" font-size="26" fill="white">Unity in Worship</text>
  <text x="50%" y="580" dominant-baseline="middle" text-anchor="middle" font-family="'Inter', sans-serif" font-size="16" fill="white">Grace Family Fellowship</text>
</svg>`;

export const SVG_BACK_PRESET_1 = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1920" width="100%" height="100%">
  <defs>
    <linearGradient id="backGrad" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="%232c1b06" />
      <stop offset="50%" stop-color="%235c390d" />
      <stop offset="100%" stop-color="%23120b02" />
    </linearGradient>
    <radialGradient id="glow" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="%23db8504" stop-opacity="0.25" />
      <stop offset="100%" stop-color="%23120b02" stop-opacity="0" />
    </radialGradient>
  </defs>
  <rect width="100%" height="100%" fill="url(%23backGrad)" />
  <circle cx="540" cy="960" r="700" fill="url(%23glow)" />
  <!-- Subtle sparkles and crosses in background -->
  <g opacity="0.35">
    <path d="M 300 400 L 300 430 M 285 415 L 315 415" stroke="%23fff5e8" stroke-width="2"/>
    <path d="M 800 600 L 800 630 M 785 615 L 815 615" stroke="%23fff5e8" stroke-width="2"/>
    <path d="M 200 1200 L 200 1230 M 185 1215 L 215 1215" stroke="%23fff5e8" stroke-width="2"/>
    <path d="M 750 1400 L 750 1430 M 735 1415 L 765 1415" stroke="%23fff5e8" stroke-width="2"/>
  </g>
</svg>`;

export const DEFAULT_PRESETS: GDQEventGame[] = [
  {
    id: 'marriage_anniversary',
    category: 'Wedding',
    celebrants: 'Sarah & Jonathan',
    place: 'Grand Imperial Cathedral',
    date: '2026-06-20',
    contacts: '+1-555-0199',
    backgroundImage: SVG_BACK_PRESET_1,
    isTemplate: true,
    puzzles: [
      {
        id: 'wed_ps_1',
        name: 'Bridal Joy Celebration',
        imageUrl: SVG_WEDDING_PUZZLE_1,
        thumbnailUrl: SVG_WEDDING_PUZZLE_1,
        verseBook: 'Genesis',
        verseChapter: 2,
        verseVerse: 24,
        verseText: 'Therefore a man shall leave his father and his mother and hold fast to his wife, and they shall become one flesh.',
        thankYouMessage: 'May the Lord establish your home in love, and keep you united in truth and faith all the days of your lives. We offer our prayers for Jonathan & Sarah.'
      },
      {
        id: 'wed_ps_2',
        name: 'The Golden Covenant Ring',
        imageUrl: SVG_WEDDING_PUZZLE_2,
        thumbnailUrl: SVG_WEDDING_PUZZLE_2,
        verseBook: 'Mark',
        verseChapter: 10,
        verseVerse: 9,
        verseText: 'What therefore God has joined together, let not man separate.',
        thankYouMessage: 'Father, thank You for joining our hearts. Let Your peace rule in Sarah & Jonathan’s union. Amen.'
      }
    ]
  },
  {
    id: 'golden_jubilee',
    category: 'Birthday',
    celebrants: 'David Miller',
    place: 'Saint Luke Fellowship Hall',
    date: '2026-07-04',
    contacts: '+1-555-0110',
    backgroundImage: SVG_BACK_PRESET_1,
    isTemplate: true,
    puzzles: [
      {
        id: 'bday_ps_1',
        name: 'The Crown of Life Jubilee',
        imageUrl: SVG_BIRTHDAY_PUZZLE_1,
        thumbnailUrl: SVG_BIRTHDAY_PUZZLE_1,
        verseBook: 'Proverbs',
        verseChapter: 16,
        verseVerse: 31,
        verseText: 'Gray hair is a crown of glory; it is gained in a righteous life.',
        thankYouMessage: 'We praise God for David’s 50 years of rich faith! May Him keep guiding, protecting, and granting you the wisdom and crowns of honor.'
      }
    ]
  },
  {
    id: 'grace_church_gala',
    category: 'Church',
    celebrants: 'Grace Chapel Family',
    place: 'Grace Chapel Sanctuary',
    date: '2026-09-12',
    contacts: '+1-555-9988',
    backgroundImage: SVG_BACK_PRESET_1,
    isTemplate: true,
    puzzles: [
      {
        id: 'church_ps_1',
        name: 'Unity in Worship Fellowship',
        imageUrl: SVG_CHURCH_PUZZLE_1,
        thumbnailUrl: SVG_CHURCH_PUZZLE_1,
        verseBook: 'Psalms',
        verseChapter: 133,
        verseVerse: 1,
        verseText: 'Behold, how good and pleasant it is when brothers dwell in unity!',
        thankYouMessage: 'O Lord, bless this sanctuary and your congregation with peace, fellowship, and infinite glory as they walk in your commandments. Amen.'
      }
    ]
  }
];

export const ALL_BIBLE_BOOKS = [
  'Genesis', 'Exodus', 'Leviticus', 'Numbers', 'Deuteronomy', 
  'Joshua', 'Judges', 'Ruth', '1 Samuel', '2 Samuel', '1 Kings', '2 Kings',
  '1 Chronicles', '2 Chronicles', 'Ezra', 'Nehemiah', 'Esther', 'Job',
  'Psalms', 'Proverbs', 'Ecclesiastes', 'Song of Solomon', 'Isaiah',
  'Jeremiah', 'Lamentations', 'Ezekiel', 'Daniel', 'Hosea', 'Joel',
  'Amos', 'Obadiah', 'Jonah', 'Micah', 'Nahum', 'Habakkuk', 'Zephaniah',
  'Haggai', 'Zechariah', 'Malachi', 'Matthew', 'Mark', 'Luke', 'John',
  'Acts', 'Romans', '1 Corinthians', '2 Corinthians', 'Galatians',
  'Ephesians', 'Philippians', 'Colossians', '1 Thessalonians', '2 Thessalonians',
  '1 Timothy', '2 Timothy', 'Titus', 'Philemon', 'Hebrews', 'James',
  '1 Peter', '2 Peter', '1 John', '2 John', '3 John', 'Jude', 'Revelation'
];
